import React from "react";
import Bundles from "src/pages/gh_market/Bundles";
import ShowBundle from "src/pages/gh_market/Bundles/Show";

const ghMarketRoutes = [
  { path: '/gh_market/bundles',     element: <Bundles /> },
  { path: '/gh_market/bundles/:id', element: <ShowBundle /> },
]

export default ghMarketRoutes;
